export default "/images/arr-m-r.svg?3685d770e03738da36a91e0b4d296a9b";